/**
 * Cómo se desplaza la pantalla cuando el CÓDIGO la mueve (Historia 1.14 · NFR-10).
 *
 * ## Por qué hace falta, si `styles.css` ya apaga el movimiento
 *
 * El apagado general pone `scroll-behavior: auto !important` bajo
 * `prefers-reduced-motion: reduce`, y eso alcanza a todo desplazamiento que el
 * NAVEGADOR decide: un ancla, un `scroll-smooth` de Tailwind. **No alcanza a un
 * `behavior: 'smooth'` explícito**: la opción de `scrollIntoView`/`scrollTo` manda
 * sobre la propiedad de CSS. Medido con Playwright el 2026-09-17 sobre el hilo de
 * la bandeja, con `reducedMotion: 'reduce'` y la regla global puesta: el
 * `scrollTop` cada 40 ms fue 9, 52, 145, 316, 618, 1145… — animaba igual.
 *
 * Por eso ningún componente escribe `'smooth'` a mano: pide el comportamiento acá,
 * y el gate (`src/gate/foco-y-movimiento.spec.ts`) se pone rojo si aparece un
 * `behavior` suave literal fuera de este archivo.
 */

/** La consulta del sistema operativo. La misma que usa el apagado de `styles.css`. */
export const CONSULTA_MOVIMIENTO_REDUCIDO = '(prefers-reduced-motion: reduce)';

/**
 * `'auto'` (salta, sin recorrido) para quien pidió menos movimiento; `'smooth'` para el resto.
 *
 * Se consulta en cada llamada y no una vez al arrancar: la preferencia se puede
 * cambiar con la consola abierta, y el próximo mensaje ya tiene que respetarla.
 *
 * Sin `matchMedia` (un entorno de pruebas, un navegador muy viejo) se elige
 * `'auto'`: ante la duda, no mover.
 */
export function comportamientoDelDesplazamiento(): ScrollBehavior {
  if (typeof globalThis.matchMedia !== 'function') return 'auto';
  return globalThis.matchMedia(CONSULTA_MOVIMIENTO_REDUCIDO).matches ? 'auto' : 'smooth';
}
